
/**Handles multiple files uploaded at once */
// export const uploadMultipleFilesToS3 = async (imageArray: any[], headers: any) => {
//     const workload = [];
//     for (let i = 0; i < imageArray.length; i++) {
//         const imgObj = imageArray[i];
//         workload.push(uploadFileToS3(imgObj.file, imgObj.fileName, headers, imgObj.path));
//     }
//     const urlArray = await Promise.all(workload);
//     const urlObj: any = {};
//     for (let j = 0; j < urlArray.length; j++) {
//         urlObj["url_" + urlArray[j]?.key] = urlArray[j]?.url;
//     }
//     return urlObj;
// };

import API, { HTTPMethods } from "./API";
import { getDynamicEnviroment } from "../yoello-lib/modules/utils/enviromentSetup";
import { v4 as uuidv4 } from 'uuid';

/** Handles the upload of files to s3
 * First gets a token from our API for s3
 * then creates a form object  appending the file
 * then attempts to save the file to s3
 */
const env = getDynamicEnviroment();

let urlStarter = "";
if (env === "dev") {
    urlStarter = "dev-";
} else if (env === "staging") {
    urlStarter = "staging-";
}
export const uploadFileToS3 = async (file: File | "delete", tokenFunction: any, path?: string): Promise<IS3UploadReturnObject> => {
    if (file!=="delete" && (!file || !file.name)) {
        throw new Error("No file sent to upload file");
    }
    if (file === "delete") {
        return { key: '', url: '' }
    }
    const fileName = uuidv4();
    const api = new API(tokenFunction);
    const ext = getFileExtension(file);
    const createdFileName = fileName + ext;
    const fileNameAndPath = path + createdFileName;
    const params = {
        "file-name": fileNameAndPath,
        "file-type": file.type
    };
    const { url, fields } = await api.makeHTTPRequest(`${urlStarter}v3-menus/sign-s3`, HTTPMethods.GET, { params });
    const s3API = new API(undefined, url);

    let formData = s3API.createFormDataWithObject(fields);
    formData.append("file", file, createdFileName);
    try {
        await s3API.makeHTTPRequest("", HTTPMethods.POST, { body: formData });
        return {
            key: fileName,
            url: url + "/" + fileNameAndPath
        };
    } catch (error) {
        throw error;
    }
};

export const getFileExtension = (file: File) => {
    return "." + file.name.split('.').pop();
};

interface IS3UploadReturnObject {
    key: string;
    url: string;
}